import * as React from 'react';
import { makeStyles, createStyles, Box, Typography } from '@material-ui/core';
import cn from 'classnames';
import { CheckCircle as CheckedIcon } from '@material-ui/icons';
import { TranquiTheme } from '../App/theme';

interface TitleAndSubTitleTextProps {
  className?: string;
  title: string;
  subtitle?: string;
  secondHeader?: boolean
  showCheckIcon?: boolean;
}

const TitleAndSubTitleText = (props: TitleAndSubTitleTextProps) => {
  const { className, title, subtitle, secondHeader, showCheckIcon } = props;
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  const classes = useStyles();

  return (
    <Box className={cn(classes.root, className)}>
      <Typography
        className={cn(classes.subtitle, secondHeader && classes.subtitleSecond)}
        data-test="cy-generalSubtitle-text"
      >
        {title}
        {showCheckIcon && <CheckedIcon className={cn(classes.icon, 'ml-1')} data-test="cy-generalTitle-icon" />}
      </Typography>
      {subtitle && (
        <Typography
          variant="h3"
          className={cn(classes.title, secondHeader && classes.titleSecond)}
          data-test="cy-generalTitle-h3"
        >
          {subtitle}
        </Typography>
      )}
    </Box>
  );
};

const useStyles = makeStyles((theme: TranquiTheme) => createStyles({
  root: {},
  icon: {
    color: theme.palette.primary.main,
    width: '0.75em',
    height: '0.75em',
  },
  subtitle: {
    ...theme.typography.capitalize as any,
    color: theme.palette.text5.main,
    textTransform: 'uppercase',
    display: 'flex',
    alignItems: 'center',
  },
  subtitleSecond: {
    ...theme.typography.capitalize as any,
    color: theme.palette.text5.main,
    textTransform: 'uppercase',
  },
  title: {
    ...theme.typography.h3,
    color: theme.palette.indigo.main,
  },
  titleSecond: {
    ...theme.typography.h6,
    color: theme.palette.indigo.main,
    fontWeight: 600,
  },
}));

export default TitleAndSubTitleText;
